import { useQuery } from "@tanstack/react-query";
import { fetchTopGifts } from "@/api/reportsTopGifts";
import type { TopGiftsListParams } from "@/interfaces/reportsTopGifts";

/** Query key root for the Top Gifts report list — other units invalidate/prefetch against it. */
export const TOP_GIFTS_QUERY_KEY = ["reports", "top-gifts"] as const;

/**
 * GET /reports/top-gifts, keyed by every param so distinct campaign/date filters cache
 * independently. `enabled` lets the page hold the request while permissions are still loading.
 */
export function useReportsTopGifts(params?: TopGiftsListParams, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: [...TOP_GIFTS_QUERY_KEY, "list", params],
    queryFn: () => fetchTopGifts(params),
    enabled: options?.enabled,
  });
}
